module.exports = __webpack_public_path__ + "static/img/logo-title-v3.58fc0f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-title-v3.png
// module id = OIYX
// module chunks = 1